
// src/web/components/division-group-management-panel.jsx

import React from 'react'
import connect from '../../connects/division-groups-manager-panel.js'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import {
  List,
  ListItem,
  ListItemContent,
} from 'react-toolbox/lib/list'
import {
  IconMenu,
  MenuItem,
  MenuDivider,
} from 'react-toolbox/lib/menu'
import Dropdown from 'react-toolbox/lib/dropdown'
import Switch from 'react-toolbox/lib/switch'
import ConfirmDialog from './confirm-dialog.jsx'
import GuideMessage from './guide-message.jsx'
import theme from './themes/flat-card.css'
import successButtonTheme from './themes/success-button.css'
import lightButtonTheme from './themes/light-button.css'
import sortableTheme from './themes/sortable.css'
import groupMembersSortingTheme from './themes/group-members-sorting.css'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'
import { track } from '../../helpers/analytics'
import _ from 'lodash'


class DivisionGroupManagementPanel extends React.Component {
  state = { scale: 1.5, sorting: false }

  showGroupSelectionDialog = () => {
    this.props.showGroupSelectionDialog(
      this.props.t('label:Select_group'), true,
      'OTHER_GROUPS', undefined,
      (groups)=> this.props.addDivisionGroups(this.props, groups)
    )
    track('division_groups_add')
  }
  render() {
    const {
      t,
      showGroupSelectionDialog,
      division,
      groups,
    } = this.props
    if (!division || !groups || groups.length == 0)
      return null
    const division_groups = division.groups.map(g => groups.find(group => group.group_id == g.id)).filter(g => g)

    return (
      <Card theme={theme}>
        <CardActions>

          <Button raised theme={successButtonTheme}
            icon='add'
            label={t('label:既存グループを追加')}
            onClick={this.showGroupSelectionDialog} />
        </CardActions>
        <CardText>
          <SortableGroupsList {...this.props} groups = {division_groups}
          helperClass={sortableTheme.sortable}/>
        </CardText>
      </Card>
    )
  }
}


class GroupsList extends React.Component {
  state = {}
  showRemoveGroupSelectionDialog = () => {
    this.setState({ [`deleteConfirm${group.group_id}`]: false })
    updateDivisionGroup(this.props, group, 'remove')
    updateUI({ active: true })
  }

  render() {
    const {
      t,
      updateUI,
      groups,
      sorting,
      selectSorting,
      updateDivisionGroup,
    } = this.props

    return (
      <div style={{ cursor: sorting && 'move' || 'inherit' }}>
        <List>
          {_.map(groups, (group, i)=>
            <SortableListItem key={group.group_id} selectable={false} ripple={false} index={i}
                theme={groupMembersSortingTheme}
                className={(selectSorting ? 'active_sorting' : '') + ' ' + group.access_type}
                disabled={!sorting}
                avatar={group.icon_image.thumb_url}
                caption={group.name}
                rightActions={_.filter([
                  <IconButton key="remove" icon="close" onClick={()=> this.setState({ [`deleteConfirm${group.group_id}`]: true })} />,
                  <ConfirmDialog key="remove_dialog"
                      title={t('label:can_i_remove_group', { name: group.name })}
                      description={t('label:division_group_remove_consequence')}
                      open={this.state[`deleteConfirm${group.group_id}`]}
                      yesLabel={t('label:外す')}
                      noLabel={t('label:取り消し')}
                      onYes={()=> { this.setState({ [`deleteConfirm${group.group_id}`]: false })
                                    updateDivisionGroup(this.props, group, 'remove')
                                    updateUI({ active: true }) }}
                      onNo={()=> this.setState({ [`deleteConfirm${group.group_id}`]: false })} />
                ], (item)=> item)}
              >
                  <ListItemContent>
                  <div>
                    <p style={{ color: 'rgb(33, 33, 33)', fontSize: 16 }}>{group.name}</p>
                    <p style={{ color: 'rgb(117, 117, 117)' }}>{ t('label:persons_count', { value: group.members_count }) }</p>
                  </div>
                  </ListItemContent>
              </SortableListItem>
          )}
        </List>
      </div>
    )
  }
}
const SortableGroupsList = SortableContainer(GroupsList)
const SortableListItem = SortableElement(ListItem)
export const RawDivisionGroupManagementPanel = DivisionGroupManagementPanel
export default connect(DivisionGroupManagementPanel)



// WEBPACK FOOTER //
// ./src/web/components/division-group-management-panel.jsx